import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Project } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

type UpdateSecurityModeParams = {
  enabled: boolean;
};

export const useUpdateSecurityMode = (
  projectId: string,
  options: Omit<UseMutationOptions<Project, UnprocessableEntityError, UpdateSecurityModeParams, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Project, UnprocessableEntityError, UpdateSecurityModeParams, unknown>({
    mutationFn: async ({ enabled }): Promise<Project> => {
      const response = await api.patch<Project>(`/projects/${projectId}/security-mode`, { enabled });
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects"],
      });
    },
    ...options
  });
};
